import { ReactElement } from 'react'
import { CalendarX2Icon } from 'lucide-react'

export type SchedulingUnavailableShadcnComponentProps = {
  title: string
  message: string
}

export function SchedulingUnavailableShadcnComponent({
  title,
  message,
}: SchedulingUnavailableShadcnComponentProps): ReactElement {
  return (
    <div className="theme-light text-strong grid min-h-screen place-items-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-xl border border-slate-200 bg-surface p-8 text-center shadow-sm sm:p-12">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
          <CalendarX2Icon className="h-8 w-8 text-slate-500" />
        </div>
        <h1 className="mb-3 text-2xl font-semibold text-slate-900">{title}</h1>
        <p className="whitespace-pre-line text-base text-slate-600">{message}</p>
      </div>
    </div>
  )
}
